/* =============================================================
 * HIP&TELL — hitung mundur kampanye
 * =============================================================
 * Satu skrip untuk semua hitung mundur di toko: halaman landing giveaway,
 * bar pengumuman, dan strip statistik di tab akun. Ditaruh di satu berkas
 * karena ketiganya harus SELALU menunjukkan angka yang sama — kalau tiap
 * tempat punya penghitungnya sendiri, satu-satunya cara ketahuan beda adalah
 * ada yang kebetulan membuka dua halaman bersebelahan.
 *
 * ZONA WAKTU
 * Targetnya ditulis lengkap dengan offset, mis. "2026-09-30T23:59:00+07:00".
 * Itu satu titik waktu absolut, jadi pembeli di Malaysia, Singapura, atau di
 * mana pun melihat sisa waktu yang sama persis menuju momen WIB yang sama.
 * JANGAN pernah menulis targetnya tanpa offset — tanpa itu, browser membacanya
 * sebagai waktu lokal masing-masing dan hitungannya melenceng berjam-jam.
 *
 * KONTRAK DOM
 *   <div data-ht-countdown="2026-09-30T23:59:00+07:00">
 *     <span data-ht-cd="days"></span>     ← 2 digit
 *     <span data-ht-cd="hours"></span>
 *     <span data-ht-cd="minutes"></span>
 *     <span data-ht-cd="seconds"></span>
 *   </div>
 *
 *   <span data-ht-countdown="..." data-ht-cd="compact"></span>   ← "21D 08:14:52"
 *
 * Saat waktunya habis, akar hitung mundur diberi data-ht-cd-expired="true"
 * dan semua angka jadi nol. Bagian yang perlu menghilang setelah kampanye
 * berakhir (bar pengumuman) menyandarkan diri pada penanda itu lewat CSS.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  // Section bisa dirender ulang berkali-kali di theme editor. Tanpa penjaga
  // ini, tiap render menambah satu timer lagi yang tidak pernah berhenti.
  if (window.__htCountdown) return;
  window.__htCountdown = true;

  var SECOND = 1000;
  var MINUTE = 60 * SECOND;
  var HOUR = 60 * MINUTE;
  var DAY = 24 * HOUR;

  var roots = [];
  var timer = null;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /** Kumpulkan ulang simpul hitung mundur yang ada di halaman sekarang. */
  function collect() {
    roots = [];

    var found = document.querySelectorAll('[data-ht-countdown]');
    for (var i = 0; i < found.length; i++) {
      var el = found[i];
      var target = Date.parse(el.getAttribute('data-ht-countdown') || '');

      // Target yang tidak terbaca dilewati diam-diam, TAPI dicatat: lebih baik
      // hitung mundurnya kosong daripada halaman menampilkan "NaN" ke pembeli.
      if (!isFinite(target)) {
        if (window.console) {
          console.warn('[ht-countdown] target tidak terbaca, dilewati:', el);
        }
        continue;
      }

      roots.push({
        el: el,
        target: target,
        compact: el.getAttribute('data-ht-cd') === 'compact',
        fields: el.querySelectorAll('[data-ht-cd]')
      });
    }
  }

  function paint(entry, now) {
    var left = entry.target - now;
    var expired = left <= 0;
    if (expired) left = 0;

    var d = Math.floor(left / DAY);
    var h = Math.floor((left % DAY) / HOUR);
    var m = Math.floor((left % HOUR) / MINUTE);
    var s = Math.floor((left % MINUTE) / SECOND);

    if (entry.compact) {
      entry.el.textContent = pad(d) + 'D ' + pad(h) + ':' + pad(m) + ':' + pad(s);
    } else {
      for (var i = 0; i < entry.fields.length; i++) {
        var field = entry.fields[i];
        var unit = field.getAttribute('data-ht-cd');
        var value =
          unit === 'days' ? d :
          unit === 'hours' ? h :
          unit === 'minutes' ? m :
          unit === 'seconds' ? s : null;

        if (value !== null) {
          var text = pad(value);
          // Menulis hanya saat berubah: tiga dari empat angka diam sepanjang
          // detik, dan menulis ulang teks yang sama memaksa layout tiap detik.
          if (field.textContent !== text) field.textContent = text;
        }
      }
    }

    if (expired) {
      entry.el.setAttribute('data-ht-cd-expired', 'true');
    } else if (entry.el.hasAttribute('data-ht-cd-expired')) {
      entry.el.removeAttribute('data-ht-cd-expired');
    }

    return expired;
  }

  function tick() {
    var now = Date.now();
    var allExpired = true;

    for (var i = 0; i < roots.length; i++) {
      if (!paint(roots[i], now)) allExpired = false;
    }

    // Semua sudah lewat — tidak ada lagi yang perlu dihitung. Timer dimatikan
    // supaya halaman kampanye yang basi tidak terus membakar satu tick per
    // detik di ponsel orang.
    if (allExpired) stop();
  }

  function start() {
    stop();
    if (!roots.length) return;
    tick();
    timer = window.setInterval(tick, SECOND);
  }

  function stop() {
    if (timer !== null) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  function refresh() {
    collect();
    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  // Theme editor mengganti isi section tanpa memuat ulang halaman; simpul lama
  // yang kita pegang jadi yatim dan angkanya membeku. Kumpulkan ulang.
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
})();
